import { defineStore } from "pinia"
import { computed, ref } from "vue"
import * as env from "@resn/gozer-env"
import { PageState } from "~/providers/page/pageState"

export const useAppStore = defineStore("app", () => {
  const pageState = ref("")
  const pageReady = computed(
    () =>
      pageState.value === PageState.EnterStart ||
      pageState.value === PageState.EnterComplete
  )
  const firstPageRoute = ref(true)

  const setPageState = (val: string) => {
    pageState.value = val
    // console.log('🚀 ~ setPageState ~ val:', val);

    switch (val) {
      case PageState.LeaveStart:
        setScrollPaused(true)
        setLoadProgress(0)
        break
      case PageState.EnterStart:
        setScrollPaused(false)
        break

      default:
        break
    }
  }

  const loadProgress = ref(0)
  const setLoadProgress = (val: number) => {
    loadProgress.value = val
  }

  const scroller = ref(null)
  const setScroller = (val: any) => {
    scroller.value = val
  }

  const scrollPaused = ref(true)
  const setScrollPaused = function (val) {
    // console.log("🚀 ~ setScrollPaused ~ val:", val)
    scrollPaused.value = val
  }
  const toggleScrollPaused = function () {
    scrollPaused.value = !scrollPaused.value
  }

  const modalId = ref(null)
  const setModalId = (val) => {
    // console.log("🚀 ~ setModalId ~ val:", val)
    modalId.value = val
  }

  // const inModalStory = ref(false)
  // const setInModalStory = (val) => {
  //   inModalStory.value = val
  // }
  const modalStoryId = ref(null)
  const setModalStoryId = (val, evt) => {
    modalStoryId.value = val
    if (evt) {
      evt.preventDefault()
    }
  }

  const cards = ref([])
  const addCard = (val) => {
    // cards.value.push(val)
    cards.value = [...new Set([...cards.value, val])]
  }
  const removeCard = (val) => {
    cards.value = cards.value.filter((id) => id !== val)
  }

  const locations = ref([])

  const addLocation = (id) => {
    locations.value.push(id)
  }

  const removeLocation = (id) => {
    locations.value = locations.value.filter((location) => location.id !== id)
  }

  const hoverLocation = ref(null)
  const setHoverLocation = (val) => {
    hoverLocation.value = val
  }

  return {
    pageReady,
    pageState,

    firstPageRoute,
    setPageState,

    loadProgress,
    setLoadProgress,

    scroller,
    setScroller,
    scrollPaused,
    setScrollPaused,

    // Generic Modal (Menu, etc.)
    modalId,
    setModalId,

    // Story Modal (Job, News, Project, Product, Environment, etc.)
    // inModalStory,
    // setInModalStory,
    modalStoryId,
    setModalStoryId,

    cards,
    addCard,
    removeCard,

    // MAP
    locations,
    addLocation,
    removeLocation,
    hoverLocation,
    setHoverLocation,
  }
})

// if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot));
